import React from "react";
import "./skills.css";

const E = () => {
  return (
    <>
      <iframe
        src="https://d28xe8vt774jo5.cloudfront.net/champion-abilities/0080/ability_0080_E1.webm"
        title="Passiva"
        className="video"
      />
    </>
  );
};

export default E;